var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoExclamationmark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2.92,
    height: 11.715,
    viewBox: "0 0 2.92 11.715",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_1_exclamationmark",
    transform: "translate(-383.027 -157.623)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46764",
    "data-name": "Path 46764",
    d: "M384.481,166.848a.675.675,0,0,0-.078,0,1.178,1.178,0,0,0-1.107,1.243c0,.026,0,.052,0,.078a1.176,1.176,0,0,0,1.186,1.167c.034,0,.068,0,.1,0a1.165,1.165,0,0,0,1.084-1.242,1.033,1.033,0,0,0,0-.124A1.155,1.155,0,0,0,384.481,166.848Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46765",
    "data-name": "Path 46765",
    d: "M383.028,159.377a22.626,22.626,0,0,0,.987,5.207c.188.622.753.611.932,0a23.035,23.035,0,0,0,1-5.207C385.947,157.033,383.028,157.044,383.028,159.377Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoExclamationmark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_exclamationmark.5290ee64e2befda3e41566dcbef2afbb.svg";